import { render, staticRenderFns } from "./PlatformMapping.vue?vue&type=template&id=fdc8b766&scoped=true&"
import script from "./PlatformMapping.vue?vue&type=script&lang=js&"
export * from "./PlatformMapping.vue?vue&type=script&lang=js&"
import style0 from "./PlatformMapping.vue?vue&type=style&index=0&id=fdc8b766&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc8b766",
  null
  
)

export default component.exports